<template lang="pug">
    .operacoes-em-lote
        BaseHeader(
            :titulo="$t('mensagens.operacoesLote.titulo')"
            :exibeBotao="true"
            icon="el-icon-download"
            :btnTexto="$t('mensagens.operacoesLote.downloadTemplate')"
            @btnHeaderClicado="downloadTemplate"
            :exibeBotaoSecundario="isEmpresaItau"
            :btnTextoSecundario="$t('mensagens.operacoesLote.uploadPlanilha')"
            @btnHeaderClicadoSecundario="showModalUpload = true"
        )

        ModalUploadCadastroOperacaoEmLote(
            :show.sync="showModalUpload"
            @atualizar="carregarPlanilhas"
        )

        .view-container-base-header
            .estatisticas-container.mb-4
                .estatistica-card
                    .estatistica-icon
                        i.el-icon-document
                    .estatistica-content
                        .estatistica-valor {{ totalPlanilhas }}
                        .estatistica-label Total de Planilhas

                .estatistica-card.info
                    .estatistica-icon
                        i.el-icon-finished
                    .estatistica-content
                        .estatistica-valor {{ totalValidando }}
                        .estatistica-label Validando

                .estatistica-card.success
                    .estatistica-icon
                        i.el-icon-circle-check
                    .estatistica-content
                        .estatistica-valor {{ totalProcessadas }}
                        .estatistica-label Processadas

                .estatistica-card.error
                    .estatistica-icon
                        i.el-icon-warning-outline
                    .estatistica-content
                        .estatistica-valor {{ totalComErro }}
                        .estatistica-label Com Erros

                .estatistica-card.warning
                    .estatistica-icon
                        i.el-icon-time
                    .estatistica-content
                        .estatistica-valor {{ totalAguardando }}
                        .estatistica-label Aguardando

            .tabela
                .table-scroll
                    el-table(
                        :data="planilhas"
                        v-loading="loading"
                    )
                        el-table-column(prop='id', :label="$t('mensagens.operacoesLote.tabela.id')", min-width='100')
                        el-table-column(prop='nomeUsuario', :label="$t('mensagens.operacoesLote.tabela.nomeUsuario')", min-width='400')
                        el-table-column(prop='status', :label="$t('mensagens.operacoesLote.tabela.status.label')", min-width='400', align='center')
                            .template(slot-scope='scope')
                                label(:class='"status-label " + scope.row.status') {{ $t('mensagens.operacoesLote.tabela.status.' + scope.row.status) }}
                        el-table-column(prop='dataCadastroFormatada', :label="$t('mensagens.operacoesLote.tabela.dataCadastro')", min-width='200')
                        el-table-column(min-width='50', align='center', :label="$t('mensagens.operacoesLote.tabela.acoes.label')")
                            .template(slot-scope='scope')
                                el-dropdown.acoes(trigger='click', v-if="scope.row.status !== 'VALIDANDO'")
                                    span.el-dropdown-link
                                        i.mdi.mdi-dots-vertical

                                    el-dropdown-menu(slot='dropdown')
                                        el-dropdown-item(
                                            v-if="scope.row.status === 'PROCESSADO' || scope.row.status === 'PROCESSADO_COM_ERRO'"
                                            @click.native='verDetalhes(scope.row)'
                                        )
                                            | {{ $t('mensagens.operacoesLote.tabela.acoes.verDetalhes') }}

                                        el-dropdown-item(
                                            @click.native="downloadPlanilha(scope.row.id, 'ORIGINAL')"
                                        )
                                            | {{ $t('mensagens.operacoesLote.tabela.acoes.downloadPlanilhaOriginal') }}

                                        el-dropdown-item(
                                            v-if="scope.row.status === 'PROCESSADO_COM_ERRO' || scope.row.status === 'VALIDADO_COM_ERRO'"
                                            @click.native="downloadPlanilha(scope.row.id, 'ERRO')"
                                        )
                                            | {{ $t('mensagens.operacoesLote.tabela.acoes.downloadPlanilhaComErros') }}

                                span(v-else)
                                    i.el-icon-loading

                        template(slot='empty')
                            el-empty(:description="$t('mensagens.operacoesLote.emptyTemplate')")
                .py-3.btn-paginacao(style='text-align: center')
                    el-pagination(
                        background,
                        :page-size='paginacao.tamanhoPagina',
                        :current-page.sync='paginacao.paginaAtual',
                        layout='prev, pager, next',
                        :total='totalPlanilhas',
                        @current-change='carregarPlanilhas'
                    )

</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import OperacaoService from '@/services/OperacaoService';
import ModalUploadCadastroOperacaoEmLote from '@/components/operacao/gestao/ModalUploadCadastroOperacaoEmLote';
import empresaUtils from '@/utils/empresaUtils';
import { mapState } from 'vuex';

export default {
    name: 'OperacoesEmLote',
    components: {
        BaseHeader,
        ModalUploadCadastroOperacaoEmLote
    },
    data() {
        return {
            loading: false,
            planilhas: [],
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 20
            },
            totalPlanilhas: 0,
            pollingInterval: null,
            showModalUpload: false
        };
    },
    computed: {
        ...mapState(['usuarioLogado']),
        isEmpresaItau() {
            return empresaUtils.isNomeGrupoItau(this.usuarioLogado?.nameGroup);
        },
        totalValidando() {
            return this.planilhas.filter(p => p.status === 'VALIDANDO').length;
        },
        totalProcessadas() {
            return this.planilhas.filter(p => p.status === 'PROCESSADO').length;
        },
        totalComErro() {
            return this.planilhas.filter(p =>
                p.status === 'PROCESSADO_COM_ERRO' || p.status === 'VALIDADO_COM_ERRO'
            ).length;
        },
        totalAguardando() {
            return this.planilhas.filter(p =>
                p.status === 'AGUARDANDO_PROCESSAMENTO' || p.status === 'EM_PROCESSAMENTO'
            ).length;
        },
        temItensEmAndamento() {
            return this.planilhas.some(p =>
                p.status === 'VALIDANDO' || p.status === 'EM_PROCESSAMENTO'
            );
        }
    },
    created() {
        this.carregarPlanilhas();
    },
    mounted() {
        this.iniciarPolling();
    },
    beforeDestroy() {
        this.pararPolling();
    },
    methods: {
        async carregarPlanilhas() {
            try {
                this.loading = true;
                const response = await OperacaoService.listarPlanilhaCadastroOperacaoEmLote({
                    page: this.paginacao.paginaAtual - 1,
                    size: this.paginacao.tamanhoPagina
                });
                this.planilhas = response.data.resultados;
                this.totalPlanilhas = response.data.totalResultados;
            } catch (error) {
                this.$notify.error({
                    message: error
                });
            } finally {
                this.loading = false;
            }
        },
        iniciarPolling() {
            this.pollingInterval = setInterval(() => {
                if (this.temItensEmAndamento) {
                    this.carregarPlanilhas();
                }
            }, 15000);
        },
        pararPolling() {
            if (this.pollingInterval) {
                clearInterval(this.pollingInterval);
                this.pollingInterval = null;
            }
        },
        verDetalhes(planilhaData) {
            this.$router.push(`/operacao/lote/${planilhaData.id}`);
        },
        async downloadPlanilha(id, tipo) {
            await OperacaoService.downloadPlanilhaCadastroEmLote(id, tipo)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.operacao.notificacao.downloadRealizado')
                    });
                })
                .catch(() =>
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.downloadErro')
                    })
                );
        },
        async downloadTemplate() {
            await OperacaoService.downloadTemplateCadastroEmLote()
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.operacao.notificacao.downloadRealizado')
                    });
                })
                .catch(() =>
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.downloadErro')
                    })
                );
        }
    }
};
</script>

<style scoped lang="scss">
.view-container-base-header{
    .estatisticas-container {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 20px;
        margin-bottom: 20px;

        .estatistica-card {
            background: var(--white);
            border-radius: 8px;
            padding: 20px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            display: flex;
            align-items: center;
            gap: 15px;
            transition: transform 0.2s;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }

            .estatistica-icon {
                font-size: 40px;
                color: var(--primary);

                i {
                    display: block;
                }
            }

            .estatistica-content {
                flex: 1;

                .estatistica-valor {
                    font-size: 28px;
                    font-weight: bold;
                    color: var(--primary);
                    line-height: 1;
                }

                .estatistica-label {
                    font-size: 14px;
                    color: var(--primary-font-color);
                    margin-top: 5px;
                }
            }

            &.info {
                .estatistica-icon {
                    color: #409EFF;
                }
                .estatistica-valor {
                    color: #409EFF;
                }
            }

            &.success {
                .estatistica-icon {
                    color: #67C23A;
                }
                .estatistica-valor {
                    color: #67C23A;
                }
            }

            &.error {
                .estatistica-icon {
                    color: #F56C6C;
                }
                .estatistica-valor {
                    color: #F56C6C;
                }
            }

            &.warning {
                .estatistica-icon {
                    color: #E6A23C;
                }
                .estatistica-valor {
                    color: #E6A23C;
                }
            }
        }
    }

    .tabela {
        border-radius: 5px;
        overflow: hidden;
        background-color: var(--white);
        height: 100%;
        width: 100%;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        .table-scroll {
            max-height: 500px;
            overflow-y: auto;

            .status-label {
                border-radius: 20px;
                text-align: center;
                max-width: 250px;
                padding: 5px 10px;
            }

            .VALIDANDO {
                border: 1px solid var(--tag-info-border, #409EFF);
                background-color: var(--tag-info-background, #ECF5FF);
                color: var(--tag-info-text, #409EFF);
            }

            .VALIDADO_COM_ERRO {
                border: 1px solid var(--tag-danger-border);
                background-color: var(--tag-danger-background);
                color: var(--tag-danger-text);
            }

            .AGUARDANDO_PROCESSAMENTO {
                border: 1px solid var(--tag-warning-border);
                background-color: var(--tag-warning-background);
                color: var(--tag-warning-text);
            }

            .EM_PROCESSAMENTO {
                border: 1px solid var(--tag-info-border, #409EFF);
                background-color: var(--tag-info-background, #ECF5FF);
                color: var(--tag-info-text, #409EFF);
            }

            .PROCESSADO {
                border: 1px solid var(--tag-success-border);
                background-color: var(--tag-success-background);
                color: var(--tag-success-text);
            }

            .PROCESSADO_COM_ERRO {
                border: 1px solid var(--tag-danger-border);
                background-color: var(--tag-danger-background);
                color: var(--tag-danger-text);
            }
        }
        .acoes:hover {
            cursor: pointer;
        }
    }
}
</style>
